<div class="marker-dialog">
  <div class="d-flex justify-content-between align-items-center mb-2">
    <span><i class="bi bi-brush"></i> Brush Size</span>
    <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="close()"></button>
  </div>
  <input type="range" min="1" max="20" [(ngModel)]="brushSize" class="form-range" (input)="setWidth($event)" />

  <div class="d-flex justify-content-between align-items-center mt-3 mb-2">
    <span><i class="bi bi-palette"></i> Color palette</span>
  </div>

  <div class="d-flex flex-wrap gap-2">
    @for (color of colors; track color) {
      <div
        class="color-circle"
        [ngStyle]="{ 'background-color': color }"
        [class.selected]="selectedColor === color"
        (click)="selectColor(color)"
        >
        <i class="bi bi-pencil-fill text-white"></i>
      </div>
    }
  </div>


  <div class="mt-3 text-center text-white">
    <small>Click and drag on the globe to draw</small>
  </div>
</div>
